export var SessionScope;
(function (SessionScope) {
    SessionScope["SESSION_SCOPE_ORG"] = "ORG";
    SessionScope["SESSION_SCOPE_ACCOUNT"] = "ACCOUNT";
})(SessionScope || (SessionScope = {}));
